module.exports = __webpack_public_path__ + "static/media/dfv_loading.8c4faef8.png";